import { MainDashboardContentDomID } from "@/constants/mainDashboardContentDomID";
import { observeResizeWithAnimationFrame } from "@/utility/observeResizeWithAnimationFrame";
import { useEffect, useState } from "react";

export interface BrowserWindowSize {
  width: number;
  height: number;
  x?: number;
  y?: number;
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState<undefined | BrowserWindowSize>();

  useEffect(() => {
    const mainEl = document.getElementById(MainDashboardContentDomID) ?? document.body;
    if (!mainEl) {
      return;
    }

    const updateSize = () => {
      const rect = mainEl.getBoundingClientRect();
      const nextWindowSize = {
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        x: Math.round(rect.x),
        y: Math.round(rect.y),
      };

      setWindowSize((previousWindowSize) => {
        if (
          previousWindowSize &&
          previousWindowSize.width === nextWindowSize.width &&
          previousWindowSize.height === nextWindowSize.height &&
          previousWindowSize.x === nextWindowSize.x &&
          previousWindowSize.y === nextWindowSize.y
        ) {
          return previousWindowSize;
        }

        return nextWindowSize;
      });
    };

    updateSize();

    return observeResizeWithAnimationFrame(mainEl, () => {
      updateSize();
    });
  }, []);

  return windowSize;
}
